import React from 'react';
import {useDispatch} from 'react-redux';
import {
  Button,
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@material-ui/core';
import * as yup from 'yup';
import {Formik} from 'formik';
import { createSubscriptionBenefitApi, updateSubscriptionBenefitApi} from 'api/subscription';


export default ({item, setSelected}) => {
  const dispatch = useDispatch();

  return (
    <>
      <Formik
        initialValues={{
          _id: item._id,
          title: item.title,
          period: item.period,
          isEnabled: item.isEnabled
        }}
        onSubmit={async (values) => {
          if (values._id) {
            await updateSubscriptionBenefitApi({dispatch, item: values});
          } else {
            await createSubscriptionBenefitApi({dispatch, item: values});
          }

          setSelected(null);
        }}
        validationSchema={
          yup.object({
            title: yup
              .string()
              .required('Field is required'),
            period: yup
              .string()
              .required('Field is required'),
            isEnabled: yup
              .boolean()
          })
        }
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit
        }) => (
          <form autoComplete="off" className="p-8" onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item sm={7}>
                <TextField
                  required
                  className="w-full"
                  label="Title"
                  name="title"
                  variant="outlined"
                  value={values.title}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.title && Boolean(errors.title)}
                  helperText={touched.title && errors.title}
                />
              </Grid>
              <Grid item sm={2}>
                <FormControl fullWidth>
                  <InputLabel>Period:</InputLabel>
                  <Select
                    variant="outlined"
                    label="Period"
                    name="period"
                    value={values?.period}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <MenuItem
                      value="annually"
                    >
                      annually
                    </MenuItem>
                    <MenuItem
                      value="semiAnnually"
                    >
                      semiAnnually
                    </MenuItem>
                    <MenuItem
                      value="monthly"
                    >
                      monthly
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item sm={3}>
                <FormControlLabel
                  label="Is Enabled"
                  control={
                    <Switch
                      onChange={handleChange}
                      checked={values.isEnabled}
                      color="primary"
                      name="isEnabled"
                    />}
                  labelPlacement="start"
                />
              </Grid>

              <div className="flex items-center justify-end mt-8">
                <Button
                  variant="contained"
                  onClick={() => setSelected(undefined)}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  className="mx-10"
                  type="submit"
                >
                  Save
                </Button>
              </div>
            </Grid>
          </form>
        )}
      </Formik>
    </>
  );
};
